import React from "react";
import { Avatar, Box, Chip } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const ChipFilledDisabled = () => {
  const handleClick = () => {
    console.log("On Click");
  };
  const handleDelete = () => {
    console.log("On Delete");
  };
  return (
    <Box mb={2}>
      <PreviewAndEditor
        title={"Basic Filled Disabled Chip"}
        language={"js"}
        value={"        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          label=\"Default color\"\n" +
            "          onDelete={handleDelete}\n" +
            "          onClick={handleClick}\n" +
            "          disabled={true}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          label=\"Primary color\"\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"primary\"\n" +
            "          onClick={handleClick}\n" +
            "          disabled={true}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          label=\"Secondary color\"\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"secondary\"\n" +
            "          onClick={handleClick}\n" +
            "          disabled={true}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          label=\"Error color\"\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"error\"\n" +
            "          onClick={handleClick}\n" +
            "          disabled={true}\n" +
            "        />\n" +
            "\n" +
            "        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          label=\"Warning color\"\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"warning\"\n" +
            "          onClick={handleClick}\n" +
            "          disabled={true}\n" +
            "        />\n" +
            "\n" +
            "        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          label=\"Info color\"\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"info\"\n" +
            "          onClick={handleClick}\n" +
            "          disabled={true}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          label=\"Success color\"\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"success\"\n" +
            "          onClick={handleClick}\n" +
            "          disabled={true}\n" +
            "        />"}
      >
        <Chip
          avatar={<Avatar>H</Avatar>}
          label="Default color"
          onDelete={handleDelete}
          onClick={handleClick}
          disabled={true}
        />
        <Chip
          avatar={<Avatar>H</Avatar>}
          label="Primary color"
          onDelete={handleDelete}
          color="primary"
          onClick={handleClick}
          disabled={true}
        />
        <Chip
          avatar={<Avatar>H</Avatar>}
          label="Secondary color"
          onDelete={handleDelete}
          color="secondary"
          onClick={handleClick}
          disabled={true}
        />
        <Chip
          avatar={<Avatar>H</Avatar>}
          label="Error color"
          onDelete={handleDelete}
          color="error"
          onClick={handleClick}
          disabled={true}
        />

        <Chip
          avatar={<Avatar>H</Avatar>}
          label="Warning color"
          onDelete={handleDelete}
          color="warning"
          onClick={handleClick}
          disabled={true}
        />

        <Chip
          avatar={<Avatar>H</Avatar>}
          label="Info color"
          onDelete={handleDelete}
          color="info"
          onClick={handleClick}
          disabled={true}
        />
        <Chip
          avatar={<Avatar>H</Avatar>}
          label="Success color"
          onDelete={handleDelete}
          color="success"
          onClick={handleClick}
          disabled={true}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default ChipFilledDisabled;
